import axios from "axios";


export const API_BASE_URL = "https://api.thirukkural.milkbikis.ilovebritannia.com/api";
// export const API_BASE_URL = "https://ji-a50bc0a783eb411caee6e8f61a609847.ecs.ap-south-1.on.aws/api";
// export const API_BASE_URL = "http://localhost:8005/api";

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});
export default api;



export function handleAxiosError(err) {
  let userMessage = 'Something went wrong.';
  let errorCode = 'GEN-000';

  // ---------- Axios errors ----------
  if (axios.isAxiosError(err)) {

    // 1️⃣ Request was made but no response (network / CORS / DNS / server down)
    if (!err.response) {

      // Timeout
      if (err.code === 'ECONNABORTED') {
        userMessage = 'Request timed out. Please try again.';
        errorCode = 'NET-001';
      }
      // Browser blocked request (CORS / offline)
      else if (err.message === 'Network Error') {
        userMessage = 'Unable to connect to server. Check your internet.';
        errorCode = 'NET-002';
      }
      // Unknown network issue
      else {
        userMessage = 'Network connection failed.';
        errorCode = 'NET-003';
      }
    }

    // 2️⃣ Server responded with error
    else {
      const status = err.response.status;

      switch (status) {
        case 400:
          userMessage = 'Invalid request. Please check your input.';
          errorCode = 'HTTP-400';
          break;

        case 401:
          userMessage = 'Session expired. Please log in again.';
          errorCode = 'HTTP-401';
          break;

        case 403:
          userMessage = 'You do not have permission to perform this action.';
          errorCode = 'HTTP-403';
          break;

        case 404:
          userMessage = 'Requested resource not found.';
          errorCode = 'HTTP-404';
          break;

        case 409:
          userMessage = 'Conflict detected. Please refresh and try again.';
          errorCode = 'HTTP-409';
          break;

        case 422:
          userMessage =
            err.response.data?.message ||
            'Provided data is invalid.';
          errorCode = 'HTTP-422';
          break;

        case 429:
          userMessage =
            err.response.data?.message ||
            'Too many requests. Please wait and try again.';
          errorCode = 'HTTP-429';
          break;

        case 500:
          userMessage = 'Server encountered an error.';
          errorCode = 'HTTP-500';
          break;

        case 502:
        case 503:
        case 504:
          userMessage = 'Service temporarily unavailable.';
          errorCode = `HTTP-${status}`;
          break;

        default:
          userMessage = 'Unexpected server error.';
          errorCode = `HTTP-${status}`;
      }
    }

    return {
      message: userMessage,
      code: errorCode,
      debug: {
        axiosCode: err.code,
        status: err.response?.status,
      },
    };
  }

  // ---------- Non-Axios / Runtime errors ----------
  return {
    message: 'Unexpected application error.',
    code: 'APP-001',
    debug: {
      error: String(err),
    },
  };
}
/* =========================
   REQUEST INTERCEPTOR
========================= */
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* =========================
   RESPONSE INTERCEPTOR
========================= */
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const requestUrl = error?.config?.url || "";

    // ✅ Public routes (NO redirect)
    const publicRoutes = [
      "/user/check-auth",
      "/user/register",
      "/user/login",
      "/user/send-otp",
      "/user/verify-otp",
      "/sku/upload-sku"
    ];

    const isPublicRoute = publicRoutes.some((route) =>
      requestUrl.includes(route)
    );

    if ((status === 401 || status === 403) && !isPublicRoute) {
      if (!window.location.pathname.includes("/login")) {
        localStorage.clear();
        window.location.replace("/login");
      }
    }

    return Promise.reject(error);
  }
);

